(function () {
    'use strict';

    angular
        .module('app.completions')
        .factory('completionsService', completionsService);

    //completionsService.$inject = ['completions.dialog'];

    /* @ngInject */
    function completionsService() {
        var service = {
            sort: sort,
            isCompletionType: isCompletionType,
            getLastCompletionForType: getLastCompletionForType,
            hasCompletionType: hasCompletionType,
            isAllDone: isAllDone,
            isNothingCompleted: isNothingCompleted,
   
        };

        return service;

        function sort(completions) {
            completions.sort(function (a, b) {
                a = new Date(a.DateAddedUtc);
                b = new Date(b.DateAddedUtc);
                return a > b ? -1 : a < b ? 1 : 0
            });
        }
        

        
        
        function isCompletionType(completionTypeId) {
            return function (element) {
                return element.CompletionTypeId == completionTypeId;
            }
        }

        function isAllDoneType() {
            return function (element) {
                return element.IsAllDoneType;
            }
        }

        function getLastCompletionForType(completionTypeId, item) {
            var completions = item.Completions.filter(isCompletionType(completionTypeId));
            completions.sort(function (a, b) {
                a = new Date(a.DateAddedUtc);
                b = new Date(b.DateAddedUtc);
                return a > b ? -1 : a < b ? 1 : 0
            });

            return completions[0];
        }

        function isAllDone(item) {
            var allDoneTypeId = 0;
            var allDoneTypeItems = item.Completions.filter(isAllDoneType());
            if (allDoneTypeItems.length > 0) {
                allDoneTypeId = allDoneTypeItems[0].CompletionTypeId;
            }
            var com = getLastCompletionForType(allDoneTypeId, item);
            
            if (com) {
                if (com.CompletedAtUtc != null) {
                    return true;
                }
            }
            return false;
        }

        function isNothingCompleted(item, completionTypes) {
            for (var i = 0; i < completionTypes.length; i++) {
                var completion = getLastCompletionForType(completionTypes[i].ID, item);
                if (completion) {
                    if (completion.CompletedAtUtc != null) {
                        return false;
                    }
                }
            }
            return true;

        }


        function hasCompletionType(ct, item) {
            var completion = getLastCompletionForType(ct.ID, item);
            if (completion) {
                if (completion.CompletedAtUtc != null) {
                    return true;
                }
            }
            return false;
        }


    }
}());
